import { Link } from '@/components';
import {
  ArrowRightIcon,
  Box,
  Flex,
  Text,
  textShortener
} from '@blockanalitica/ui';
import { ReactNode, useMemo } from 'react';
import styled from 'styled-components';

type TCrumb = {
  href: string;
  text: ReactNode;
};

type BreadcrumbsProps = {
  crumbs: TCrumb[];
};

const Breadcrumb = styled(Text)`
  text-transform: capitalize;
`;

export default function Breadcrumbs({ crumbs }: BreadcrumbsProps) {
  return (
    <Flex gap="2xs" display="inline-flex" alignItems="center" flexWrap="wrap">
      {crumbs.map((crumb, index) => (
        <Crumb
          key={crumb.href}
          last={crumbs.length === 1 || index === crumbs.length - 1}
          {...crumb}
        />
      ))}
    </Flex>
  );
}

type TCrumbProps = TCrumb & {
  last: boolean;
};

function Crumb({ href, text, last }: TCrumbProps) {
  const crumbChildren = useMemo(() => {
    if (typeof text === 'string') {
      if (text.startsWith('0x')) {
        return textShortener(text, {
          threshold: 11,
          firstSliceLength: 6,
          secondSliceLength: 4
        });
      }

      const val = text.split('-').join(' ');
      return textShortener(val, {
        threshold: 63,
        firstSliceLength: 4,
        secondSliceLength: 4
      });
    }

    return text;
  }, [text]);

  if (last) {
    return <Breadcrumb size="2">{crumbChildren}</Breadcrumb>;
  }

  return (
    <Flex display="inline-flex" gap="2xs" alignItems="center">
      <Box
        //@ts-ignore
        as={Link}
        to={href}
        fontSize="-1">
        {crumbChildren}
      </Box>
      <ArrowRightIcon size={12} />
    </Flex>
  );
}
